import { render } from "./Satzung.vue?vue&type=template&id=4b5c9806"
import script from "./Satzung.vue?vue&type=script&lang=js"
export * from "./Satzung.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\afm.git - Kopie\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__